<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" *ngIf="ir" (click)="uj()"><ion-icon name="add"></ion-icon>Új vevő</button>
      <input type="search" [(ngModel)]="kereso" placeholder="Keresés névre, adószámra…">
      <span class="spacer"></span><span class="halvany">{{ lathato.length }} vevő</span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs sz-racs">
        <thead><tr><th>Név</th><th>Típus</th><th>Adószám</th><th>Cím</th><th>E-mail</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of lathato" class="kattinthato" [class.halvany-sor]="!+p.aktiv" (click)="nyit(p)">
            <td><b>{{ p.nev }}</b></td><td>{{ tipusNev(p.tipus) }}</td><td>{{ p.adoszam || p.kozossegi_adoszam }}</td>
            <td>{{ p.orszag !== 'HU' ? p.orszag + ' ' : '' }}{{ p.irsz }} {{ p.telepules }}{{ p.cim ? ', ' + p.cim : '' }}</td><td>{{ p.email }}</td>
          </tr>
        </tbody>
      </table>
      <div class="sz-ures" *ngIf="!lathato.length">Még nincs vevő.</div>
    </div>
  </ng-container>
</div>

<ion-modal [isOpen]="!!szerk" (didDismiss)="bezar()" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? szerk.nev : 'Új vevő' }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
        <div class="sa-doboz">
          <label class="kv-mezo" style="grid-column:1/-1"><span>Név</span><input type="text" [(ngModel)]="szerk.nev" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Típus</span>
            <select [(ngModel)]="szerk.tipus" [disabled]="!ir">
              <option value="belfoldi">Belföldi cég (adószámos)</option><option value="maganszemely">Magánszemély</option>
              <option value="eu">EU-s cég</option><option value="harmadik">Harmadik országbeli</option></select></label>
          <label class="kv-mezo" *ngIf="szerk.tipus === 'belfoldi' || szerk.tipus === 'harmadik'"><span>Adószám</span>
            <span class="kv-egyutt"><input type="text" [(ngModel)]="szerk.adoszam" [disabled]="!ir" placeholder="12345678-1-12">
              <button type="button" class="ov-gomb" *ngIf="ir && szerk.tipus === 'belfoldi'" [disabled]="navFut" (click)="navLekeres()" title="Ellenőrzés és kitöltés a NAV adataiból">NAV</button></span></label>
          <label class="kv-mezo" *ngIf="szerk.tipus === 'eu' || szerk.tipus === 'belfoldi'"><span>Közösségi adósz.</span><input type="text" [(ngModel)]="szerk.kozossegi_adoszam" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Ország</span><input type="text" maxlength="2" [(ngModel)]="szerk.orszag" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Irányítószám</span><input type="text" [(ngModel)]="szerk.irsz" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Település</span><input type="text" [(ngModel)]="szerk.telepules" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Cím</span><input type="text" [(ngModel)]="szerk.cim" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>E-mail</span><input type="email" [(ngModel)]="szerk.email" [disabled]="!ir"></label>
          <label class="kv-mezo" style="grid-column:1/-1"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" [disabled]="!ir"></label>
          <label class="sa-jelolok"><input type="checkbox" [(ngModel)]="szerk.aktiv" [disabled]="!ir"> aktív (felkínálja a számlán)</label>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" *ngIf="ir" [disabled]="zar && !zar.irhato" (click)="ment()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="bezar()">Bezár</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
